export default "__VITE_ASSET__71b54479__"